// Given a string, return a lowercase and slugified version of it.
// Example: "Hello World" -> "hello-world"

/**
 * Returns a slugified version of the input string.
 * @param str - The string to be slugified.
 * @returns The slugified string.
 */
export const slugify = (str: string): string => {
    return str
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
}
